import TidalEffect from './TidalEffect.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

export default class LinkedTidal extends TidalEffect {
    constructor(track) {
        super(track);

        this.name = "Linked Tidal";

        this.cycleFactorParameter = new AbstractParameter(
            'cycleFactor', this, (o, x) => {
            },
            {
                defaultValue: 1,
                min: 0,
                max: 16,
                unit: '',
            });
        this.registerParameter(this.cycleFactorParameter);

        this.linkedEffect = undefined;
    }

    set cycle(x) {
        this._cycle = x;
    }

    get cycleFactor() {
        return this.cycleFactorParameter.get();
    }

    get cycleLength() {
        return this.linkedEffect ?
            this.linkedEffect.cycleLength *
            this.cycleFactor :
            super.cycleLength;
    }

    get cycle() {
        return this.linkedEffect ?
            this.linkedEffect.cycle :  this._cycle;
    }

    var(x) {
        if (this.linkedEffect) {
            return this.linkedEffect.var(x);
        }
        return super.var(x);
    }
    
    get durationFactor() {
        return this.linkedEffect ?
            this.linkedEffect.durationFactor :
            super.durationFactor;
    }

    get lengthFactor() {
        return this.linkedEffect ?
            this.linkedEffect.lengthFactor :
            super.lengthFactor;
    }

    replaceOperandVariables(cycle) {
        if (this.linkedEffect) {
            return this.linkedEffect.replaceOperandVariables(cycle);
        }
        return super.replaceOperandVariables(cycle);
    }

    getJson() {
        return {
            ...super.getJson(),
            linkedEffect: this.linkedEffect.id
        };
    }

    fromJson(json) {
        // find the tidal we want
        let bulk = super.fromJson(json);
        let id = json.linkedEffect;
        if (id) {
            this.lostParameters = this.loadParameters([id]);
        }
        return bulk;
    }

    loadParameters(list) {
        let id = list[0];

        for (let track of this.track.sequencerEngine.tracks) {
            let effect = track.midiEffects.effects.find(x => x.id === id);
            if (effect) {
                this.linkedEffect = effect;
                return undefined;
            }
        }
        return [id];
    }
}
